export const ADD_AREA_PARAMETER = 'ADD_AREA_PARAMETER';
export const UPDATE_AREA_PARAMETER = 'UPDATE_AREA_PARAMETER';
export const DELETE_AREA_PARAMETER = 'DELETE_AREA_PARAMETER';



// WEBPACK FOOTER //
// ./src/areaParameters/areaParametersActionTypes.js